import React, { useEffect, Fragment, } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { keyBy, omit, mapValues, } from 'lodash';
import { useList, } from 'react-use';

import useFormState from '../hooks/useFormState';
import Field from '../Field';
import { setFields as fields, setItemFields, } from '../../shared/models/product';
import ListForm from '../ListForm';
import ProductSelectOptionLabel from '../ProductSelectOptionLabel';

const { entries, } = Object;

export default function SetFormModal(props) {
  const { isOpen, values, chunkProducts, tenant, onClickClose, renderFooterContent = _ => _, isSubmitDisabled = false, } = props;
  const originalItems = values?.items || [];
  const originalItemByProductId = keyBy(originalItems, 'productId');
  const products = chunkProducts;
  const isNew = !values || !values.id;
  const [items, { set: setItems, updateAt: updateItemAt }] = useList(values?.items || [{ productId: null, quantity: 1 }]);
  const statedFields = useFormState(values, omit(fields({ tenant, otherProducts: products.filter(_ => _.id !== values?.id), }), 'productTagIds'), isOpen);
  const isUnsubmittable =
    Object.values(statedFields).some(_ => !_.isValid) ||
    items.length === 0 ||
    items.some(_ => !_.isValid);
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    await props.onSubmit({ ...mapValues(statedFields, 'value'), items: items.map(_ => ({ ...originalItemByProductId[_.productId], ...omit(_, 'isValid') })), });
  };

  return (
    <Modal isOpen={isOpen} style={{ minWidth: 800 }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            セット品{isNew ? '追加' : '編集'}
          </h5>
        </div>
      </div>
      {
        isSubmitDisabled && (
          <div className="alert alert-warning">
            すでに出荷依頼があるため編集できません
          </div>
        )
      }
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <Fragment>
            <div className="alert alert-info small">
              セット品は実在庫を持ちません。在庫は構成品から自動計算され、モールへ送信されます。
            </div>
            <div>
              {
                entries(statedFields).map(([fieldName, fieldSetting]) => (
                  <Field
                    key={fieldName}
                    name={fieldName}
                    documentName="set"
                    {...fieldSetting}
                  />
                ))
              }
            </div>
            <div className="mt-3">
              <ListForm
                initialItem={_ => ({ quantity: 1 })}
                addButtonLabel="構成品追加"
                items={items}
                renderItem={(item, itemIndex) => {
                  return (
                    <div className="card p-3">
                      <ItemForm
                        fields={setItemFields({ items, products, })}
                        index={itemIndex}
                        values={item}
                        products={products}
                        tenant={tenant}
                        onChange={_ => updateItemAt(itemIndex, { ...item, ..._, })}
                      />
                    </div>
                  );
                }}
                onChange={setItems}
                minItems={1}
                renderFooterContent={(base) => {
                  return (
                    <div className="d-flex gap-1 align-items-start">
                      {base}
                    </div>
                  );
                }}
              />
            </div>
          </Fragment>
        </ModalBody>
        <ModalFooter>
          {
            renderFooterContent((
              <Fragment>
                <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
                <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable || isSubmitDisabled}>保存</Button>
              </Fragment>
            ), { items, onSubmit, isUnsubmittable, })
          }
        </ModalFooter>
      </Form>
    </Modal>
  );
};

function ItemForm (props) {
  const { index: itemIndex, fields, values, onChange, products, } = props;
  const statedFields = useFormState(values, fields, values);
  // セット品・ケース品はネストできない。Amazon商品もセット品には含めない
  const filteredProducts = products.filter(_ => !_.isCase && !_.isSet && !_.isAmazonProduct);
  const productOptions = filteredProducts.map((product) => {
    const { id, sku, code, asin, } = product;
    return {
      value: id,
      queryLabel: [id, sku, code, asin].join(' '),
      label: (
        <ProductSelectOptionLabel product={product} />
      ),
    };
  });
  useEffect(() => {
    onChange({
      ...mapValues(statedFields, 'value'),
      isValid: Object.values(statedFields).every(_ => _.isValid),
    });
  }, [...Object.values(statedFields).map(_ => _.value), ...Object.values(statedFields).map(_ => _.isValid)]);

  return (
    <div>
      <div className="d-flex flex-wrap">
        {
          entries(statedFields).map(([fieldName, fieldSetting], i) => {
            const width = ({
              productId: 500,
              quantity: 100,
            })[fieldName] || 200;
            return (
              <div className="mr-2" style={{ width, }} key={fieldName}>
                <Field
                  name={fieldName}
                  {...fieldSetting}
                  {...(itemIndex === 0 && i === 0 && { inputProps: { autoFocus: true, } })}
                  {...(fieldName === 'productId' && {
                    options: productOptions,
                    inputProps: {
                      styles: {
                        valueContainer: _ => ({ ..._, height: 60 }),
                        singleValue: _ => ({ ..._, top: 0, transform: '' }),
                      },
                    },
                  })}
                />
              </div>
            );
          })
        }
      </div>
    </div>
  );
}
